<template>
  <div class="my_select_time">
    <el-input size="small" v-model="startInput" class="time1" placeholder="请输入"></el-input>
    <div class="time_to_text" style="color: #666666">~</div>
    <el-input size="small" v-model="endInput" class="time2" placeholder="请输入"></el-input>
  </div>
</template>

<script>
export default {
  name: 'inputRange',
  props: {
    startValue: {
      type: String,
      default: ''
    },
    endValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    startInput: {
      handler(newValue, oldValue) {
        this.$emit('update:startValue', newValue)
      },
      deep: true
    },
    endInput: {
      handler(newValue, oldValue) {
        this.$emit('update:endValue', newValue)
      },
      deep: true
    },
     startValue: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.startInput = this.startValue;
        }
      }
    },
    endValue: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.endInput = this.endValue
        }
        } }
  },
  data() {
    return {
      startInput: '',
      endInput: ''
    }
  },
  mounted() {
    this.startInput = this.startValue;
    this.endInput = this.endValue
        console.log(this.startValue);
    console.log(this.endValue);
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">
.my_select_time {
  position: relative;
  display: inline-block;

  .time_to_text {
    display: inline-block;
    font-size: 1px;
    padding: 0px !important;
    height: 32px;
    line-height: 32px;
    border-top: 1px solid #b7bcc6;
    color: #666666;
    margin-top: 0px !important;
    border-bottom: 1px solid #b7bcc6;
    vertical-align: bottom;
    text-align: center;
    width: 14px;
  }

  .to_text_disabled {
    background: #f5f7fa;
    cursor: not-allowed;
  }

  .time1 {
    width: 140px;
    /deep/.el-input__inner {
      font-size: 13px;
      padding: 0 7px !important;
      border-right: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      @media screen and(max-width:1440px){
        font-size: 12px;
      }
    }
  }

  .time2 {
    width: 145px;
    /deep/.el-input__inner {
      font-size: 13px;
      border-left: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      padding: 0 20px 0 8px !important;
      @media screen and(max-width:1440px){
        font-size: 12px;
      }
    }
  }

  .date_icon2,
  .date_icon1 {
    position: absolute;
    right: 5px;
    height: 32px;
    line-height: 32px;
    width: 16px;
    font-size: 16px;
  }

  .date_icon1 {
    display: none;
    cursor: pointer;
  }
}
.my_select_time:hover {
  .date_icon2 {
    display: none;
  }

  .date_icon1 {
    display: inline-block;
  }
}
</style>